import AnchorLink from "react-anchor-link-smooth-scroll";
import "./style.css";
import whtasapp from "../../images/whatsapp-icon.svg";
import { useEffect, useState } from "react";

const Scrollbar = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 100) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  return (
    <div className="col-lg-12">
      <div className="header-menu">
      <ul className="smothscroll" style={{ display: isVisible ? "block" : "none" }}>
          <li>
            <AnchorLink href="#scrool">
              <i className="ti-arrow-up"></i>
            </AnchorLink>
          </li>
        </ul>
      </div>

      <div className="whatsapp-icon" id="whatsapp-icon">
        <a
          href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer"
        >
          <img src={whtasapp} alt="WhatsApp" />
      </a>
      </div>
    </div>
  );
};

export default Scrollbar;
